import { render } from "./ExtractForm.vue?vue&type=template&id=20585c42&scoped=true"
import script from "./ExtractForm.vue?vue&type=script&lang=ts"
export * from "./ExtractForm.vue?vue&type=script&lang=ts"

import "./ExtractForm.vue?vue&type=style&index=0&id=20585c42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20585c42"

export default script